// Styles
// Import here or directly into vue.config.js entries
import 'Styles/global.scss';

// Libs
import Vue from 'vue';
import Vuex from 'vuex';
import lazySizes from 'lazysizes';
import InputHandler from '../utils/inputHandler';

// Components - Keep imports in alpabetical order
import VchCardArticle from 'Components/cards/card-article';
import VchCardProduct from 'Components/cards/card-product';
import VchCardScroller from 'Components/card-scroller/card-scroller';
import VchCardVideo from 'Components/cards/card-video';
import VchCarouselIndicator from 'Components/carousel-indicator/carousel-indicator';
import VchChannelAdvisor from 'Components/channel-advisor/channel-advisor';
import VchContactForm from 'Components/contact-form/contact-form';
import VchCreateAccount from 'Components/create-account/create-account.vue';
import VchLanguageSelector from 'Components/language-selector/language-selector';
import VchNewsletterForm from 'Components/newsletter-form/newsletter-form';
import VchDsfAppWrapper from 'Components/dsf-app-wrapper/dsf-app-wrapper.vue';
import VchFilterList from 'Components/filter-list/filter-list';
import VchForgotPassword from 'Components/forgot-password/forgot-password';
import VchFullWidthSlider from 'Components/full-width-slider/full-width-slider';
import VchLoader from 'Components/loader/loader';
import VchLoadScript from 'Components/loadscript/loadscript';
import VchMediaGallery from 'Components/media-gallery/media-gallery.vue';
import VchZoomImage from 'Components/zoom-image/zoom-image.vue';
import VchPdpModal from 'Components/zoom-image/pdp-modal.vue';
import VchModal from 'Components/modal/modal';
import VchMyaccountDashboardHeader from 'Components/myaccount-dasboard-header/myaccount-dashboard-header';
import VchMyaccountLogout from 'Components/myaccount-logout/myaccount-logout';
import VchMyCredentials from 'Components/my-credentials/my-credentials';
import VchMyInformation from 'Components/my-information/my-information';
import VchWishlistIcon from 'Components/wishlist-icon/wishlist-icon';
import VchMyWishlistAllProducts from 'Components/my-wishlist-all-products/my-wishlist-all-products';
import VchMyInformationForm from 'Components/my-information-form/my-information-form';
import VchNewsletterSignup from 'Components/newsletter-signup/newsletter-signup';
import VchPackageSizeSelector from 'Components/package-size-selector/package-size-selector';
import VchProductCardRating from 'Components/ratings-reviews/product-card-rating/product-card-rating.vue';
import VchProductFilters from 'Components/product-filters/filters-desktop/product-filters.vue';
import VchProductFiltersMobile from 'Components/product-filters/filters-mobile/product-filters-mobile.vue';
import VchProductFiltersDesktop from 'Components/product-filters/filters-desktop/product-filters-desktop.vue';
import VchResetPassword from 'Components/reset-password/reset-password';
import VchRetailersItemList from 'Components/retailers-item-list/retailers-item-list.vue';
import VchScroller from 'Components/scroller/scroller.vue';
import VchRfpMctb from 'Components/scroller/vchRfpMctb.vue';
import VchSignIn from 'Components/sign-in/sign-in.vue';
import VchSlider from 'Components/cards-slider/slider';
import VchStickyBar from 'Components/sticky-action-bar/sticky-bar';
import VchVariantImage from 'Components/variant-image/variant-image';
import VchVideoContent from 'Components/content/video-content/video-content';
import VchVideoModal from 'Components/video-modal/video-modal';
import BazaarVoiceWrapper from 'Components/bazaar-voice-wrapper/bazaar-voice-wrapper';
import VchPdpTextImage from 'Components/pdp-text-image/pdp-text-image';
import CollapseList from 'Components/collapse-list/collapse-list';
import Collapse from 'Components/collapse/collapse';
import Sustainabilitymodal from 'Components/sustainabilitymodal/sustainabilitymodal';
import Sustainability from 'Components/sustainability/sustainability';
import ProductEnvImpactScore from 'Components/product-env-impact-score/product-env-impact-score';
import ProductTestingForm from 'Components/product-testing-form/product-testing-form';
import VchImageCarousel from 'Components/image-carousel/image-carousel';
// Directives
import { accordion } from 'Directives/accordion/accordion';
import { bus } from 'Directives/bus/bus';
import { headerNav } from 'Directives/header-nav/header-nav';
import { progressBar } from 'Directives/progress-bar/progress-bar';
import { srcset } from 'Directives/srcset/srcset';
import { stickyHeader } from 'Directives/sticky-header/sticky-header';
import { tagging } from 'Directives/tagging/tagging';
import { variantSelector } from 'Directives/variant-selector/variant-selector';
import { videoPopin } from 'Directives/video-popin/video-popin';
import VchCcModal from 'Components/cc-modal/cc-modal';
import VchBuyOnlineEcommerceBtn from 'Components/cc-modal/buy-online-ecommerce-btn';
import VchBuyOnlineEcommerceBtnShowHide from 'Components/cc-modal/buy-online-ecommerce-btn-show-hide';
import NewsletterPopupModal from 'Components/newsletter-popup/newsletter-popup-modal.vue';
import NewsletterPopupForm from 'Components/newsletter-popup/newsletter-popup.vue';

// For Lazysizes Plugin - Start
lazySizes.cfg.expand = 0;

// Configure InputHandler
InputHandler.getInputHandler();

// Components that Vue should ignore
Vue.config.ignoredElements = ['dsf-app'];

Vue.config.productionTip = false;

// Install Vue plugins
window.RefAppRatingsReviews && Vue.use(window.RefAppRatingsReviews);
window.RefAppStoreLocator && Vue.use(window.RefAppStoreLocator);
window.RefAppIframe && Vue.use(window.RefAppIframe);
window.RefAppMctb && Vue.use(window.RefAppMctb);
window.RefAppVideo && Vue.use(window.RefAppVideo);
window.joinStories && Vue.use(window.joinStories);
window.RefAppAmp && Vue.use(window.RefAppAmp);
window.RefAppFaq && Vue.use(window.RefAppFaq);
window.RefAppProductComparisonGrid && Vue.use(window.RefAppProductComparisonGrid);

// Vue.use(KeySiteCore);
Vue.use(Vuex);

// Register directives globally
Vue.directive(accordion.name, accordion);
Vue.directive(bus.name, bus);
Vue.directive(headerNav.name, headerNav);
Vue.directive(progressBar.name, progressBar);
Vue.directive(srcset.name, srcset);
Vue.directive(stickyHeader.name, stickyHeader);
Vue.directive(tagging.name, tagging);
Vue.directive(variantSelector.name, variantSelector);
Vue.directive(videoPopin.name, videoPopin);

// Register components globally - Keep in alpabetical order

Vue.component('VchCardArticle', VchCardArticle);
Vue.component('VchCardProduct', VchCardProduct);
Vue.component('VchCardScroller', VchCardScroller);
Vue.component('VchCardVideo', VchCardVideo);
Vue.component('VchCarouselIndicator', VchCarouselIndicator);
Vue.component('VchChannelAdvisor', VchChannelAdvisor);
Vue.component('VchContactForm', VchContactForm);
Vue.component('VchCreateAccount', VchCreateAccount);
Vue.component('VchLanguageSelector', VchLanguageSelector);
Vue.component('VchNewsletterForm', VchNewsletterForm);
Vue.component('VchDsfAppWrapper', VchDsfAppWrapper);
Vue.component('VchFilterList', VchFilterList);
Vue.component('VchForgotPassword', VchForgotPassword);
Vue.component('VchFullWidthSlider', VchFullWidthSlider);
Vue.component('VchLoader', VchLoader);
Vue.component('VchLoadScript', VchLoadScript);
Vue.component('VchMediaGallery', VchMediaGallery);
Vue.component('VchZoomImage', VchZoomImage);
Vue.component('VchPdpModal', VchPdpModal);
Vue.component('VchModal', VchModal);
Vue.component('VchMyaccountDashboardHeader', VchMyaccountDashboardHeader);
Vue.component('VchMyaccountLogout', VchMyaccountLogout);
Vue.component('VchMyCredentials', VchMyCredentials);
Vue.component('VchMyInformation', VchMyInformation);
Vue.component('VchMyInformationForm', VchMyInformationForm);
Vue.component('VchWishlistIcon', VchWishlistIcon);
Vue.component('VchMyWishlistAllProducts', VchMyWishlistAllProducts);
Vue.component('VchNewsletterSignup', VchNewsletterSignup);
Vue.component('VchPackageSizeSelector', VchPackageSizeSelector);
Vue.component('VchProductCardRating', VchProductCardRating);
Vue.component('VchProductFilters', VchProductFilters);
Vue.component('VchProductFiltersMobile', VchProductFiltersMobile);
Vue.component('VchResetPassword', VchResetPassword);
Vue.component('VchRetailersItemList', VchRetailersItemList);
Vue.component('VchScroller', VchScroller);
Vue.component('VchRfpMctb', VchRfpMctb);
Vue.component('VchSignIn', VchSignIn);
Vue.component('VchSlider', VchSlider);
Vue.component('VchStickyBar', VchStickyBar);
Vue.component('VchVariantImage', VchVariantImage);
Vue.component('VchVideoContent', VchVideoContent);
Vue.component('VchVideoModal', VchVideoModal);
Vue.component('BazaarVoiceWrapper', BazaarVoiceWrapper);
Vue.component('VchCcModal', VchCcModal);
Vue.component('VchProductFiltersDesktop', VchProductFiltersDesktop);
Vue.component('VchPdpTextImage', VchPdpTextImage);
Vue.component('CollapseList', CollapseList);
Vue.component('Collapse', Collapse);
Vue.component('Sustainabilitymodal', Sustainabilitymodal);
Vue.component('Sustainability', Sustainability);
Vue.component('ProductEnvImpactScore', ProductEnvImpactScore);
Vue.component('ProductTestingForm', ProductTestingForm);
Vue.component('VchBuyOnlineEcommerceBtn', VchBuyOnlineEcommerceBtn);
Vue.component(
  'VchBuyOnlineEcommerceBtnShowHide',
  VchBuyOnlineEcommerceBtnShowHide
);
Vue.component('NewsletterPopupModal', NewsletterPopupModal);
Vue.component('NewsletterPopupForm', NewsletterPopupForm);
Vue.component('VchImageCarousel', VchImageCarousel);
export default {};
